import { Fetch, AppConfig } from '../helpers'

export default class generalApi {

	static mapMarkers = (query) => {
		const response = Fetch.fetch(
			{
				methodName: "MapMarkers",
				method: "POST",
				url: AppConfig.api.general,
				data: query
			}
		)
		return response;
	}

	static betSlipConfiguration = () => {
		const response = Fetch.fetch(
			{
				methodName: "BetSlipConfiguration",
				method: "POST",
				url: AppConfig.api.general,
			}
		)

		return response;
	}

	static FormStatuses = (data) => {
		const response = Fetch.fetch(
			{
				methodName: 'FormStatuses',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}

	static GetWebFiles = () => {
		const response = Fetch.fetch(
			{
				methodName: 'GetWebFiles',
				url: AppConfig.api.general,
			}
		)
		return response;
	}

	static GetWebFile = (data) => {
		const response = Fetch.fetch(
			{
				methodName: 'GetWebFile',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}

	static BetsByBetCode = (data) => {
		const response = Fetch.fetch(
			{
				methodName: 'BetsByBetCode',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}

	static CreateBetCode = (data) => {
		const response = Fetch.fetch(
			{
				methodName: 'CreateBetCode',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}
	static getBetTypesDrillDownGroups = () => {
		const response = Fetch.fetch(
			{
				methodName: 'GetBetTypesDrillDownGroups',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static getConfiguration = (data) => {
		const response = Fetch.fetch(
			{
				methodName: 'Configuration',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}

	static getCurrencies = () => {
		const response = Fetch.fetch(
			{
				methodName: 'GetCurrencies',
				url: AppConfig.api.general,
			}
		)
		return response;
	}

	static getCountryPhoneProviders = (data) => {
		const response = Fetch.fetch(
			{
				methodName: 'GetCountryPhoneProviders',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}

	static getCountries = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetCountries',
				url: AppConfig.api.general,
			}
		)
		return response;
	}

	static getBanners = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetBannerImages',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static getCalenderIcons = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetCalendarIcons',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static getFooterProvider = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetFooterProviders',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static getCountryFlags = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetCountryFlagImages',
				url: AppConfig.api.countriesFlags,
			}
		)
		return response;
	}

	static getCounties = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetCounties',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	
	static validateCoupon = (data) => {
		const response = Fetch.fetch(
			{
				method: 'POST',
				methodName: 'ValidateCoupon',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}
	static GetLoyaltyRewardsOptions = () => {
		const response = Fetch.fetch(
			{
				method: 'POST',
				methodName: 'GetLoyaltyRewardsOptions',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static GetSportPromos = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetSportPromos',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static GetSportPromoInfo = (data) => {
		const response = Fetch.fetch(
			{
				method: 'POST',
				methodName: 'GetSportPromoInfo',
				url: AppConfig.api.general,
				data
			}
		)
		return response;
	}
	static GetHeaderTabs = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetHeaderTabs',
				url: AppConfig.api.general,
			}
		)
		return response;
	}

	static getSportTypesIcons = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetSportTypesIcons',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static GetLuckyNumberConfiguration = () => {
		const response = Fetch.fetch(
			{
				method: 'POST',
				methodName: 'GetLuckyNumberConfiguration',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static GetLandingConfiguration = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetLandingConfiguration',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static GetWorkWithUsConfiguration = () => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: 'GetWorkWithUsConfiguration',
				url: AppConfig.api.general,
			}
		)
		return response;
	}
	static GetKioskWebBannerImages = (GroupId) => {
		const response = Fetch.fetch(
			{
				method: 'GET',
				methodName: `GetKioskWebBannerImages?Id=${GroupId}`,
				url: AppConfig.api.general,
			}
		)
		return response;
	}
}